import { Component, OnInit, OnDestroy, NgZone, ViewChild } from "@angular/core";

import { Subscription } from "rxjs";

import { ModalDirective } from "ngx-bootstrap/modal";

import {} from "./../../index";
import {
  DataArray,
  AuthorizationService,
  DeviceService,
  DocumentService,
  Document,
  DeviceDocument,
  Device,
} from "./../../../shared/index";

@Component({
  selector: "device-list",
  templateUrl: "./device-list.html",
  standalone: false,
})
export class DeviceListComponent implements OnInit, OnDestroy {
  @ViewChild("skeletonKey") skeletonKey: ModalDirective; //deviceDetails
  @ViewChild("deviceDetails") deviceDetails: ModalDirective;

  public devices: DataArray<Device> = new DataArray<Device>(1);
  public documents: DeviceDocument[] = [];

  public device: Device = new Device();

  private subscriptions: Subscription[] = [];

  public ascending = true;
  public currentPage = 1;
  public total = 0;

  public processing = true;

  constructor(
    private _ngZone: NgZone,
    private _deviceService: DeviceService,
    private _documentService: DocumentService
  ) {}

  updateProcessing(isProcessing: boolean) {
    this.processing = isProcessing;
  }

  ngOnInit(): void {
    this._deviceService.ascending = true;
    this._deviceService.orderBy = "UserName";
    this._deviceService.applyFilter(this._deviceService.name);

    this.subscriptions.push(
      this._deviceService.devicesChange.subscribe(() => {
        this.processing = true;

        this._ngZone.run(() => {
          this.total = this._deviceService.totalDevices;
          this.devices.init();
          for (const device of this._deviceService.devices.Data) {
            this.devices.update(device, true);
          }
          this.processing = false;
        });
      })
    );

    this.subscriptions.push(
      this._documentService.deviceDocumentsChange.subscribe(
        (deviceDocuments: DeviceDocument[]) => {
          this._ngZone.run(() => {
            this.documents = deviceDocuments;
          });
        }
      )
    );
    this.getPage(1);
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public getPage(page: number): void {
    this.currentPage = page;
    this._deviceService.getDevices();
  }

  public sortBy(field: string): void {
    if (this._deviceService.orderBy == field) {
      this._deviceService.ascending = !this._deviceService.ascending;
    } else {
      this._deviceService.ascending = true;
      this._deviceService.orderBy = field;
    }
    this.ascending = this._deviceService.ascending;
    this._deviceService.applyFilter(this._deviceService.name);
  }

  public isSort(field: string) {
    return field == this._deviceService.orderBy;
  }

  public showSkeletonKey(device: Device): void {
    this.device = device;
    this.skeletonKey.show();
  }

  public closeSkeletonKey(): void {
    this.skeletonKey.hide();
  }

  public showDetails(device: Device): void {
    this.device = device;
    this._documentService.getDeviceDocuments(device.Id);
    this.deviceDetails.show();
  }

  public closeDetails(): void {
    this.deviceDetails.hide();
  }
}
